module.exports = __webpack_public_path__ + "img/sShkThaiX2_193x205.00e237ef.png";